import {FileError} from 'react-dropzone';
import {FileInputTextMap} from '../types';

export const getErrorMessage = (errorCode: FileError['code'], textMap: FileInputTextMap): FileError => {
    let message = '';

    switch (errorCode) {
        case 'FILE_TOO_LARGE':
            message = textMap.errorMessages.fileTooLarge;
            break;
        case 'FILE_TOO_SMALL':
            message = textMap.errorMessages.fileTooSmall;
            break;
        case 'TOO_MANY_FILES':
            message = textMap.errorMessages.tooManyFiles;
            break;
        case 'FILE_INVALID_TYPE':
        default:
            message = textMap.errorMessages.fileInvalidType;
    }

    return {
        code: errorCode,
        message
    };
};
